import { render, staticRenderFns } from "./AddContactTypes.vue?vue&type=template&id=1114ec82"
import script from "./AddContactTypes.vue?vue&type=script&lang=js"
export * from "./AddContactTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports